export default __webpack_public_path__ + "static/2.5.4/media/contactImage.9775e640.svg";